import { useEffect, useState } from "react";
import SEO from "../components/SEO";
import PageHero from "../components/PageHero";
import ProjectCard from "../components/ProjectCard";
import { FinalCTA } from "./Home";
import { getProjects } from "../lib/api";
import { PROJECT_FILTERS } from "../data/content";

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getProjects()
      .then(setProjects)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const filtered = filter === "All" ? projects : projects.filter((p) => p.type === filter || p.scope.includes(filter));

  return (
    <>
      <SEO title="Projects | ARCH EXPO" description="Concepts and ideas by ARCH EXPO — interior design, renovation and adaptation studies for residential and hospitality spaces." />
      <PageHero
        label="Projects"
        titleLines={["Concepts & ideas."]}
        intro="Design studies, renders and ideas we are exploring — a quiet look at what we love to design and build. No completed works are claimed here."
      />
      <section className="bg-paper pb-24 sm:pb-32" data-testid="projects-grid-section">
        <div className="container-ax">
          <div className="flex flex-wrap gap-2.5 mb-14" role="group" aria-label="Project filters" data-testid="project-filters">
            {PROJECT_FILTERS.map((f) => (
              <button
                key={f}
                data-testid={`filter-${f.toLowerCase()}`}
                onClick={() => setFilter(f)}
                aria-pressed={filter === f}
                className={`label-tech px-4 py-2.5 border rounded-full transition-colors duration-300 min-h-[44px] ${
                  filter === f ? "bg-coal text-paper border-coal" : "border-ink/15 text-graphite hover:border-coal hover:text-coal"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
          {loading ? (
            <p className="text-graphite" data-testid="projects-loading">Loading projects…</p>
          ) : filtered.length === 0 ? (
            <p className="text-graphite" data-testid="projects-empty">No projects in this category yet.</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-x-8 gap-y-16" data-testid="projects-grid">
              {filtered.map((p, i) => {
                const pattern = i % 3;
                const span = pattern === 0 ? "lg:col-span-7" : pattern === 1 ? "lg:col-span-5 lg:mt-20" : "lg:col-span-6 lg:col-start-4";
                return (
                  <div key={p.slug} className={`md:col-span-1 ${span}`}>
                    <ProjectCard project={p} i={i} large={pattern !== 1} />
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>
      <FinalCTA />
    </>
  );
};

export default Projects;
